// LaborLaw.jsx - Zrefaktoryzowany
import React from 'react';
import { Container, Card, Accordion, Col, Row } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaBalanceScale, FaUserGraduate, FaUmbrellaBeach, FaClock, FaBriefcase, FaShieldAlt, FaBook, FaCalendarAlt } from 'react-icons/fa';
import {
  PageContainer,
  PageHeader,
  InfoCard,
  AnimatedSection,
  accordionStyles
} from '../../../components/SharedComponents';

function LaborLaw() {
  
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  const sections = [
    {
      id: 'definition',
      icon: <FaUserGraduate size={24} />,
      title: 'Kto jest młodocianym?',
      color: '#667eea',
      content: (
        <>
          <h4 className="fw-bold mb-3">Art. 190 - Młodociany – definicja</h4>
          <div className="p-3 mb-3" style={{ background: 'rgba(102, 126, 234, 0.1)', borderRadius: '10px' }}>
            <h5 className="mb-2"><strong>§ 1.</strong> Młodocianym w rozumieniu kodeksu jest osoba, która <strong>ukończyła 15 lat, a nie przekroczyła 18 lat.</strong></h5>
            <h5 className="mb-0"><strong>§ 2.</strong> Zabronione jest zatrudnianie osoby, która nie ukończyła 15 lat, z zastrzeżeniem art. 191 § 21-23.</h5>
          </div>
        </>
      )
    },
    {
      id: 'employment',
      icon: <FaBriefcase size={24} />,
      title: 'Zasady zatrudniania',
      color: '#f093fb',
      content: (
        <>
          <h4 className="fw-bold mb-3">Art. 191 - Zasady zatrudniania młodocianych</h4>
          <div className="p-3 mb-3" style={{ background: 'rgba(255, 0, 0, 0.1)', borderRadius: '10px' }}>
            <p className="fw-bold mb-2">Wolno zatrudniać tylko tych młodocianych, którzy:</p>
            <ul>
              <li>ukończyli co najmniej ośmioletnią szkołę podstawową</li>
              <li>przedstawią świadectwo lekarskie stwierdzające, że praca danego rodzaju nie zagraża ich zdrowiu</li>
            </ul>
            <p className="mb-0"><strong>Ważne:</strong> Młodociany nieposiadający kwalifikacji zawodowych może być zatrudniony tylko w celu przygotowania zawodowego.</p>
          </div>
          
          <h6 className="fw-bold mt-4 mb-3">Szczególne przypadki (osoby poniżej 15 lat)</h6>
          <div className="p-3" style={{ background: 'rgba(245, 87, 108, 0.1)', borderRadius: '10px' }}>
            <p className="mb-2">Osoba, która ukończyła ośmioletnią szkołę podstawową, niemająca 15 lat, może być zatrudniona <strong>wymagana jest zgoda przedstawiciela ustawowego oraz pozytywna opinia poradni psychologiczno-pedagogicznej.</strong></p>
          </div>
        </>
      )
    },
    {
      id: 'vacation',
      icon: <FaUmbrellaBeach size={24} />,
      title: 'Urlop wypoczynkowy',
      color: '#4facfe',
      content: (
        <>
          <div className="p-3 mb-4" style={{ background: 'rgba(255, 0, 0, 0.1)', borderRadius: '10px' }}>
            <p className="mb-2"><strong>Ważne:</strong> W roku kalendarzowym, w którym młodociany kończy 18 lat, ma prawo do urlopu w wymiarze 20 dni roboczych.</p>
          </div>

          <h6 className="fw-bold mt-4 mb-3">Wymiar urlopu dla uczniów Branżowej Szkoły I stopnia</h6>
          <div className="p-3 mb-4" style={{ background: 'rgba(102, 126, 234, 0.1)', borderRadius: '10px' }}>
            <div className="mb-3">
              <h6 className="fw-bold mb-2">Rozpoczęcie nauki zawodu w wieku 14-15 lat:</h6>
              <ul className="mb-0">
                <li><strong>Klasa I:</strong> 38 dni roboczych (12 dni na start + 26 dni po roku pracy)</li>
                <li><strong>Klasa II:</strong> 26 dni roboczych</li>
                <li><strong>Klasa III:</strong> 26 dni roboczych* (de facto 17 dni, bo umowa jest do 31.08)</li>
              </ul>
            </div>
            
            <div className="mb-3">
              <h6 className="fw-bold mb-2">Rozpoczęcie nauki zawodu w wieku 16 lat:</h6>
              <ul className="mb-0">
                <li><strong>Klasa I:</strong> 32 dni roboczych</li>
                <li><strong>Klasa II:</strong> 26 dni roboczych</li>
                <li><strong>Klasa III:</strong> 20 dni roboczych* (de facto 13 dni, bo umowa jest do 31.08)</li>
              </ul>
            </div>
            
            <div>
              <h6 className="fw-bold mb-2">Rozpoczęcie nauki zawodu w wieku 17 lat:</h6>
              <ul className="mb-0">
                <li><strong>Klasa I:</strong> 32 dni roboczych</li>
                <li><strong>Klasa II:</strong> 20 dni roboczych</li>
                <li><strong>Klasa III:</strong> 20 dni roboczych* (de facto 13 dni, bo umowa jest do 31.08)</li>
              </ul>
            </div>
          </div>

          <div className="p-3 mb-4" style={{ background: 'rgba(255, 200, 87, 0.15)', borderRadius: '10px' }}>
            <p className="mb-0"><strong>Wyjaśnienie:</strong> Uczniowie klasy III mają naliczonych teoretycznie 20 lub 26 dni urlopu na cały rok kalendarzowy, ale ponieważ umowy kończą się z dniem 31.08, urlop jest proporcjonalnie naliczany: (26 dni ÷ 12 miesięcy) × 8 = 17 dni lub (20 dni ÷ 12 miesięcy) × 8 = 13 dni.</p>
          </div>

          <h6 className="fw-bold mt-4 mb-3">Urlop w okresie ferii szkolnych</h6>
          <div className="p-3 mb-4" style={{ background: 'rgba(79, 172, 254, 0.1)', borderRadius: '10px' }}>
            <p className="mb-2">✅ Młodocianemu uczęszczającemu do szkoły należy udzielić urlopu w okresie ferii szkolnych.</p>
            <p className="mb-0">✅ Pracodawca może udzielić zaliczkowo urlopu w okresie ferii, nawet jeśli młodociany nie nabył jeszcze prawa do urlopu.</p>
          </div>

          <h6 className="fw-bold mt-4 mb-3">Urlop bezpłatny</h6>
          <div className="p-3" style={{ background: 'rgba(230, 233, 83, 0.89)', borderRadius: '10px' }}>
            <p className="mb-3 text-dark">Na wniosek młodocianego, ucznia szkoły dla pracujących, pracodawca jest obowiązany udzielić urlopu bezpłatnego w wymiarze <strong>nieprzekraczającym łącznie z urlopem wypoczynkowym 2 miesięcy.</strong></p>
            
            <h6 className="fw-bold text-dark mb-2">A. Jeżeli młodociany NIE skończył 18 lat (15-18 lat)</h6>
            <ul className="mb-3 text-dark">
              <li>Należy powołać się na <strong>art. 205 § 4 Kodeksu pracy</strong></li>
              <li>Czas przebywania na urlopie bezpłatnym <strong>wlicza się do stażu pracy</strong></li>
              <li><strong>Pracodawca nie może tego urlopu odmówić</strong></li>
              <li>Z reguły jednak jest on możliwy do wzięcia dopiero w klasie III w okresie wakacji, gdyż jeżeli pracodawca ubiegając się o refundację przedłoży świadectwo pracy młodocianego i wykaże zbyt mało miesięcy nauki zawodu, może tej refundacji nie otrzymać</li>
            </ul>

            <h6 className="fw-bold text-dark mb-2">B. Jeżeli młodociany skończył 18 lat</h6>
            <ul className="mb-0 text-dark">
              <li>Należy powołać się na <strong>art. 174 § 2 Kodeksu pracy</strong></li>
              <li>Okres przebywania na tym urlopie <strong>NIE wlicza się do stażu pracy</strong>, istnieje więc ryzyko, że nie zrealizujesz 34 miesięcy praktycznej nauki zawodu</li>
              <li><strong>Pracodawca może odmówić</strong> udzielenia młodocianemu tego urlopu</li>
            </ul>
          </div>
        </>
      )
    },
    {
      id: 'worktime',
      icon: <FaClock size={24} />,
      title: 'Czas pracy i przerwy',
      color: '#43e97b',
      content: (
        <>
          <h4 className="fw-bold mb-3">Art. 202 - Normy czasu pracy młodocianego</h4>
          
          <Row className="g-3 mb-4">
            <Col xs={12} md={6}>
              <Card className="border-0" style={{ background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)', borderRadius: '15px' }}>
                <Card.Body className="text-center p-4">
                  <h6 className="fw-bold mb-2">Do 16 lat</h6>
                  <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#667eea' }}>nie więcej niż 6h</div>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={6}>
              <Card className="border-0" style={{ background: 'linear-gradient(135deg, rgba(240, 147, 251, 0.1) 0%, rgba(245, 87, 108, 0.1) 100%)', borderRadius: '15px' }}>
                <Card.Body className="text-center p-4">
                  <h6 className="fw-bold mb-2">Powyżej 16 lat</h6>
                  <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#f093fb' }}>nie więcej niż 8h</div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <div className="p-3 mb-3" style={{ background: 'rgba(255, 0, 0, 0.1)', borderRadius: '10px' }}>
            <p className="mb-0"><strong>Ważne:</strong> Do czasu pracy młodocianego wlicza się czas nauki w wymiarze wynikającym z obowiązkowego programu zajęć szkolnych.</p>
          </div>

          <h6 className="fw-bold mt-4 mb-3">Przerwy w pracy</h6>
          <div className="p-3" style={{ background: 'rgba(79, 172, 254, 0.1)', borderRadius: '10px' }}>
            <p className="mb-0">Jeżeli dobowy wymiar czasu pracy młodocianego jest <strong>dłuższy niż 4,5 godziny</strong>, pracodawca jest obowiązany wprowadzić <strong>przerwę w pracy trwającą nieprzerwanie 30 minut</strong>, wliczaną do czasu pracy.</p>
          </div>
        </>
      )
    },
    {
      id: 'overtime',
      icon: <FaShieldAlt size={24} />,
      title: 'Godziny nadliczbowe i praca nocna',
      color: '#f5576c',
      content: (
        <>
          <h4 className="fw-bold mb-3">Art. 203 - Zakaz zatrudniania</h4>
          
          <div className="p-4 mb-3" style={{ background: 'linear-gradient(135deg, rgba(245, 87, 108, 0.2) 0%, rgba(240, 147, 251, 0.2) 100%)', borderRadius: '15px', border: '2px solid #f5576c' }}>
            <h5 className="text-center fw-bold mb-3">Zakazy dla młodocianych</h5>
            <ul className="mb-0">
              <li className="mb-2"><strong>Młodocianego nie wolno zatrudniać w godzinach nadliczbowych</strong></li>
              <li className="mb-2"><strong>Młodocianego nie wolno zatrudniać w porze nocnej</strong></li>
            </ul>
          </div>

          <h6 className="fw-bold mb-3">Pora nocna</h6>
          <Row className="g-3 mb-3">
            <Col xs={12} md={6}>
              <div className="p-3 text-center" style={{ background: 'rgba(102, 126, 234, 0.1)', borderRadius: '10px' }}>
                <h6 className="fw-bold mb-2">Młodociany 15-18 lat</h6>
                <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>22:00 - 6:00</div>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className="p-3 text-center" style={{ background: 'rgba(245, 87, 108, 0.1)', borderRadius: '10px' }}>
                <h6 className="fw-bold mb-2">Poniżej 15 lat</h6>
                <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>20:00 - 6:00</div>
              </div>
            </Col>
          </Row>

          <div className="p-3" style={{ background: 'rgba(230, 233, 83, 0.89)', borderRadius: '10px' }}>
            <p className="mb-0 text-dark"><strong>Przerwa nocna:</strong> Przerwa w pracy młodocianego obejmująca porę nocną powinna trwać nieprzerwanie <strong>nie mniej niż 14h miedzy pracą a pracą lub pracą a szkołą.</strong></p>
          </div>
        </>
      )
    },
    {
      id: 'weekends',
      icon: <FaCalendarAlt size={24} />,
      title: 'Praca w weekendy - wolne soboty i niedziele !!!',
      color: '#38f9d7',
      content: (
        <>
          <h4 className="fw-bold mb-3">Art. 203 § 3 - Odpoczynek tygodniowy</h4>
          
          <div className="p-4 text-center" style={{ background: 'linear-gradient(135deg, rgba(67, 233, 123, 0.2) 0%, rgba(56, 249, 215, 0.2) 100%)', borderRadius: '15px', border: '2px solid #38f9d7' }}>
            <h5 className="fw-bold mb-3">Prawo do odpoczynku</h5>
            <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#38f9d7' }} className="mb-2">48 godzin</div>
            <p className="mb-0">Młodocianemu przysługuje w każdym tygodniu prawo do <strong>co najmniej 48 godzin nieprzerwanego odpoczynku</strong>, który powinien obejmować niedzielę.</p>
          </div>
        </>
      )
    },
    {
      id: 'contract',
      icon: <FaBook size={24} />,
      title: 'Umowa o pracę',
      color: '#764ba2',
      content: (
        <>
          <h4 className="fw-bold mb-3">Art. 195 - Treść umowy</h4>
          
          <div className="p-3 mb-3" style={{ background: 'rgba(118, 75, 162, 0.1)', borderRadius: '10px' }}>
            <p className="fw-bold mb-2">Umowa o pracę w celu przygotowania zawodowego powinna określać:</p>
            <ul className="mb-0">
              <li>rodzaj przygotowania zawodowego (nauka zawodu lub przyuczenie do wykonywania określonej pracy)</li>
              <li>czas trwania i miejsce odbywania przygotowania zawodowego</li>
              <li>sposób dokształcania teoretycznego</li>
              <li>wysokość wynagrodzenia</li>
            </ul>
          </div>

          <h4 className="fw-bold mt-4 mb-3">Art. 196 - Wypowiedzenie umowy</h4>
          <div className="p-3" style={{ background: 'rgba(255, 0, 0, 0.1)', borderRadius: '10px' }}>
            <p className="fw-bold mb-2">Pracodawca może wypowiedzieć umowę tylko w razie:</p>
            <ol className="mb-0">
              <li>niewypełniania przez młodocianego obowiązków wynikających z umowy o pracę lub obowiązku dokształcania się</li>
              <li>ogłoszenia upadłości lub likwidacji pracodawcy</li>
              <li>reorganizacji zakładu pracy uniemożliwiającej kontynuowanie przygotowania zawodowego</li>
              <li>stwierdzenia nieprzydatności młodocianego do pracy</li>
            </ol>
          </div>
        </>
      )
    },
    {
      id: 'obligations',
      icon: <FaBalanceScale size={24} />,
      title: 'Obowiązki pracodawcy',
      color: '#0056b3',
      content: (
        <>
          <h4 className="fw-bold mb-3">Art. 192 - Opieka i pomoc</h4>
          <div className="p-3 mb-3" style={{ background: 'rgba(0, 86, 179, 0.1)', borderRadius: '10px' }}>
            <p className="mb-0">Pracodawca jest obowiązany <strong>zapewnić młodocianym pracownikom opiekę i pomoc</strong>, niezbędną dla ich przystosowania się do właściwego wykonywania pracy.</p>
          </div>

          <h4 className="fw-bold mt-4 mb-3">Art. 193 - Ewidencja</h4>
          <div className="p-3 mb-3" style={{ background: 'rgba(102, 126, 234, 0.1)', borderRadius: '10px' }}>
            <p className="mb-0">Pracodawca jest obowiązany <strong>prowadzić ewidencję pracowników młodocianych.</strong></p>
          </div>

          <h4 className="fw-bold mt-4 mb-3">Art. 198 - Zwolnienie na naukę</h4>
          <div className="p-3" style={{ background: 'rgba(255, 0, 0, 0.1)', borderRadius: '10px' }}>
            <p className="mb-0">Pracodawca jest obowiązany <strong>zwolnić młodocianego od pracy na czas potrzebny do wzięcia udziału w zajęciach szkoleniowych</strong> w związku z dokształcaniem się.</p>
          </div>
        </>
      )
    }
  ];

  return (
    <PageContainer>
      <Container>
        <style>{accordionStyles}</style>

        <PageHeader 
          title="Prawo pracy w pigułce"
          subtitle="Wszystko co musisz wiedzieć o zatrudnianiu młodocianych"
        />

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <Accordion alwaysOpen>
              {sections.map((section, index) => (
                <motion.div
                  key={section.id}
                  {...fadeInUp}
                  transition={{ delay: index * 0.1 }}
                  className="mb-3"
                >
                  <Accordion.Item
                    eventKey={String(index)}
                    style={{
                      border: '2px solid rgba(255,255,255,0.2)',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                      background: 'rgba(180, 25, 25, 0.03)',
                      scrollMarginTop: '20px'
                    }}
                  >
                    <Accordion.Header
                      style={{
                        borderRadius: '20px'
                      }}
                      onClick={(e) => {
                        setTimeout(() => {
                          const element = e.currentTarget?.closest('.accordion-item');
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                          }
                        }, 100);
                      }}
                    >
                      <div className="d-flex align-items-center w-100">
                        <div
                          className="d-flex align-items-center justify-content-center rounded-circle me-3"
                          style={{
                            width: '50px',
                            height: '50px',
                            background: `linear-gradient(135deg, ${section.color} 0%, ${section.color}dd 100%)`,
                            color: 'white',
                            flexShrink: 0
                          }}
                        >
                          {section.icon}
                        </div>
                        <h5 className="mb-0 fw-bold text-white">{section.title}</h5>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body
                      style={{
                        background: 'rgba(255,255,255,0.05)',
                        backdropFilter: 'blur(10px)',
                        padding: '2rem',
                        color: 'white'
                      }}
                      className="text-white"
                    >
                      {section.content}
                    </Accordion.Body>
                  </Accordion.Item>
                </motion.div>
              ))}
            </Accordion>

            <AnimatedSection delay={0.8} className="mt-5">
              <InfoCard>
                <h5 className="fw-bold mb-3 text-white">Źródło danych</h5>
                <p className="mb-0" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  Wszystkie informacje pochodzą z <strong>Ustawy z dnia 26 czerwca 1974 r. – Kodeks pracy</strong> (Dz. U. 2020.1320 t.j.)
                </p>
              </InfoCard>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
}

export default LaborLaw;